/*
 * @Author: Q in
 * @Date: 2026-03-10 09:43:59
 * @LastEditors: Q in 
 * @LastEditTime: 2026-07-02 11:56:48
 * @FilePath: /new_kefu_pc/src/main-index.js
 * @Description: 客户端入口
 */
import Vue from 'vue';
import App from './App-index.vue';
import store from './store';
import ToastPlugin from '@/components/toast/plugin.js';
import { initTheme } from '@/utils/theme';
import { initAudio } from '@/utils/audio';

// 初始化音频，监听所有交互事件
initAudio(null, { debug: true });

// 全局样式
import './style/index.scss';
import './assets/icon-font/iconfont.css';

// 引入element-ui
import ElementUI from 'element-ui';
import '@/style/theme/index.scss';
Vue.use(ElementUI);

// 注册 Toast 插件
Vue.use(ToastPlugin);

// 导入消息通知组件
import MessageNotification from '@/utils/messageNotification.js';
// 挂载到 Vue 原型上
Vue.prototype.$messageNotification = MessageNotification;

// 自定义主题样式
initTheme('theme4');

// 注册VueRouter
import VueRouter from 'vue-router';
import IndexView from '@/views/index/index.vue';
Vue.use(VueRouter);

Vue.config.productionTip = false;

// 创建独立的路由实例，避免与外部项目冲突
function createRouter() {
	const router = new VueRouter({
		mode: 'abstract',
		// base: '/',
		routes: [
			{
				path: '/',
				name: 'Index',
				component: IndexView
			}
		]
	});

	router.push('/');
	return router;
}

// 关键修改：导出内容供UMD使用
// 创建客服实例的工厂函数
function createChatApp(options = {}) {
	const router = createRouter();
	return new Vue({
		router,
		store,
		render: (h) => h(App, { props: { customerId: options.customerId || '', ...options } })
	});
}

// 导出组件本身
const ChatWindow = App;

// 导出初始化方法
function initChat(selector, options = {}) {
	const container = document.querySelector(selector);
	if (!container) {
		console.error('容器 ' + selector + ' 不存在');
		return null;
	}
	const router = createRouter();
	const app = new Vue({
		router,
		store,
		render: (h) => h(App, { props: options })
	}).$mount(selector);
	return app;
}

// 挂载到window（这才是UMD需要的）
if (typeof window !== 'undefined') {
	window.CustomerService = {
		createChatApp,
		initChat,
		ChatWindow,
		version: '1.0.0',
		// 当前已挂载的组件实例（由 App-index.vue 的 mounted 设置）
		instance: null,
		/**
		 * 打开客服聊天窗口（供外部调用）
		 * 推荐用法：window.CustomerService.showKefu()
		 * 兼容旧用法：window.CustomerService.ChatWindow.methods.onClickShowKefu()
		 */
		showKefu() {
			const inst = window.CustomerService.instance;
			if (inst && inst.onClickShowKefu) {
				inst.onClickShowKefu();
				return;
			}
			// 兼容：实例尚未挂载时，直接走组件配置对象上的方法（会自动转发到 instance）
			if (window.CustomerService.ChatWindow && window.CustomerService.ChatWindow.methods && window.CustomerService.ChatWindow.methods.onClickShowKefu) {
				window.CustomerService.ChatWindow.methods.onClickShowKefu();
			} else {
				console.warn('[CustomerService] 客服实例尚未初始化，无法打开聊天窗口');
			}
		}
	};
	console.log('✅ 客户模块已加载', window.CustomerService);
}

// 开发环境直接运行
console.log('process.env.NODE_ENV', process.env.NODE_ENV);
if (process.env.NODE_ENV === 'development') {
	const router = createRouter();
	new Vue({
		router,
		store,
		render: (h) => h(App)
	}).$mount('#app');
}

// 导出模块（供import使用）
export { createChatApp, initChat, ChatWindow };
